import gql from 'graphql-tag';

export default gql`
mutation createDonation ($name: String!, $cms_url: String!, $active: DonationActiveDates!) {
    createDonation (
        input: {
            name: $name,
            cms_url: $cms_url,
            active: $active,
        }
    ) {
        id
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/createDonation.ts